/* eslint-disable react/no-unescaped-entities */
import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useApp } from "../contexts/AppContext";
import { toast } from "sonner";
import { Globe, Phone, Info } from "lucide-react";
import { CountryGrid } from "./CountryPicker";

export function RegionCard() {
  const { profile, setPays, lang, setLang } = useApp();
  const [cfg, setCfg] = useState(null);
  const region = profile?.region || "afrique";
  useEffect(() => { api.get(`/region/config?region=${region}`).then(({ data }) => { setCfg(data); localStorage.setItem("bc_region_cfg", JSON.stringify(data)); }).catch(() => { try { setCfg(JSON.parse(localStorage.getItem("bc_region_cfg"))); } catch { setCfg(null); } }); }, [region]);
  const choose = async (code) => {
    try {
      const p = await setPays(code);
      if (!p.langues.includes(lang)) setLang(p.langue_defaut);
      toast.success(`Profil ${p.pays_nom} activé`);
    } catch { toast.error("Changement impossible"); }
  };
  return (
    <div className="bg-white rounded-3xl border border-[#E4E0D5] p-5 flex flex-col gap-3" data-testid="region-card">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-[#0A1426]/70"><Globe size={16} /><span className="text-[11px] uppercase tracking-wider font-bold">Mon pays</span></div>
        {profile && <span data-testid="region-current" className="text-[12px] font-bold text-[#0A1426]">{profile.drapeau} {profile.pays_nom} · {profile.devise}</span>}
      </div>
      <CountryGrid value={profile?.pays} onChange={choose} testPrefix="region" />
      {cfg && (
        <div data-testid="region-details" className="rounded-2xl bg-[#F5F3EE] p-3 flex flex-col gap-2 text-[12px] text-[#0A1426]">
          <div className="flex flex-wrap gap-2">{cfg.urgences.map((u) => <a key={u.numero} href={`tel:${u.numero.replace(/\s/g, "")}`} data-testid="region-urgence" className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-white font-bold"><Phone size={11} className="text-[#D9534F]" /> {u.label} · {u.numero}</a>)}</div>
          <div className="text-[11px] text-[#0A1426]/70">Monnaie : {profile?.devise || cfg.monnaie} · {profile?.features?.includes("sms") ? "SMS actifs" : "SMS désactivés (push / e-mail)"} · {profile?.features?.includes("mobile_money") ? "Mobile Money disponible" : "Paiement par carte"}</div>
          {profile?.protection_donnees && <div className="text-[11px] text-[#0A1426]/70">Données : {profile.protection_donnees}</div>}
          {cfg.aides.map((a) => <div key={a.titre} className="flex gap-1.5"><Info size={13} className="shrink-0 mt-0.5 text-[#2BA3A0]" /><span><b>{a.titre} :</b> {a.texte}</span></div>)}
          <div className="text-[11px] italic text-[#0A1426]/60">{cfg.resilience}</div>
        </div>
      )}
    </div>
  );
}
